import { routePlanApis } from '@apis/dashboard/routePlanApis';
import { useMutation } from '@hooks/useMutation';
import type { PatchRoutePlan } from '@models/RoutePlan';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePatchRoutePlan = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: PatchRoutePlan) => {
      const response = await routePlanApis.patch('/dashboard/route-plan/{id}/', {
        path: { id },
        body,
      });

      if (response[400]) {
        throw new FormError('PatchRoutePlan', response[400]);
      }

      return response[200]!;
    },
    {
      onSuccess: (data) => {
        // Pre-set the data to avoid page shaking
        queryClient.setQueryData(['/dashboard/route-plan/', id], data);

        queryClient.invalidateQueries({
          predicate: (k) => k.queryKey[0] === '/dashboard/route-plan/',
        });
      },
    },
  );
};
